// extracted by mini-css-extract-plugin
export default {"firstPostContent":"D1LgxDtXGyrreJNHVOfD","blogContent":"nFiZQYmAaZeAV5gWFndX","getStartedSlice":"UQFd1Y0FiifGQJkMfHIz","getStarted":"MPr2oathdoDrCC3zmcZg"};